export default {
  register_as: "Registered as an influencer from {{- date}}",
  edit_profile: "Edit Profile",
  rating_from_admin: "Ratings from recruitment case owners as an influencer",
  sns_activity: "Influencer Activity on Social Media",
  self_introduction: "Self-introduction as an influencer (Expertise Comment)",
  cancel_change_confirm: "Cancel changes?",
  upload_avatar: "Change Profile Picture",
};
